/**
 * Transaction Constants
 * Centralized configuration for transaction-related components
 */

import { TrendingUp, TrendingDown, ArrowLeftRight } from 'lucide-react';

export const TRANSACTION_TYPE_CONFIG = {
  income: {
    icon: TrendingUp,
    label: 'Receita',
    color: 'text-green-600 dark:text-green-500',
    bgColor: 'bg-green-100 dark:bg-green-950',
    lightBg: 'bg-green-50/50',
    borderColor: 'border-green-200',
    hoverBorder: 'hover:border-green-300',
    sign: '+',
  },
  expense: {
    icon: TrendingDown,
    label: 'Despesa',
    color: 'text-red-600 dark:text-red-500',
    bgColor: 'bg-red-100 dark:bg-red-950',
    lightBg: 'bg-red-50/50',
    borderColor: 'border-red-200',
    hoverBorder: 'hover:border-red-300',
    sign: '-',
  },
  transfer: {
    icon: ArrowLeftRight,
    label: 'Transferência',
    color: 'text-blue-600 dark:text-blue-500',
    bgColor: 'bg-blue-100 dark:bg-blue-950',
    lightBg: 'bg-blue-50/50',
    borderColor: 'border-blue-200',
    hoverBorder: 'hover:border-blue-300',
    sign: '',
  },
} as const;

export const PAYMENT_STATUS_CONFIG = {
  confirmado: {
    label: 'Confirmado',
    variant: 'default' as const,
    color: 'text-green-600',
  },
  previsão: {
    label: 'Previsão',
    variant: 'secondary' as const,
    color: 'text-muted-foreground',
  },
  pendente: {
    label: 'Pendente',
    variant: 'secondary' as const,
    color: 'text-orange-600',
  },
  atrasado: {
    label: 'Atrasado',
    variant: 'destructive' as const,
    color: 'text-red-600',
  },
} as const;

export type TransactionType = keyof typeof TRANSACTION_TYPE_CONFIG;
export type PaymentStatus = keyof typeof PAYMENT_STATUS_CONFIG;
